module.exports = "<form class=\"form\" #modalForm=\"ngForm\" enctype=\"multipart/form-data\">\r\n  <div class=\"container\">\r\n    <ag-grid-angular\r\n      #agGrid1\r\n      class=\"height height-500\"\r\n      [gridOptions]=\"logGrid\"\r\n      [enableSorting]=\"true\"\r\n      [enableColResize]=\"true\">\r\n    </ag-grid-angular>\r\n  </div>\r\n</form>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/on-demand-drivers/components/change-logs/change-logs.component.html
// module id = 2477
// module chunks = 66